export interface TblDecInvMotivoProdTermin{
    iddecinvmotivoprodtermin: number
    idpersona: number
    tipomotivo: string
    motivo: string
    ultimoCambio: string
}

export function getVoidMotivo(): TblDecInvMotivoProdTermin{
    return{
        iddecinvmotivoprodtermin: 0,
        idpersona: 0,
        tipomotivo: "P",
        motivo:"",
        ultimoCambio: ""
    }
}

export function setProductoMotivo(data: any): TblDecInvMotivoProdTermin{
    return{
        iddecinvmotivoprodtermin: data.iddecinvmotivoprodtermin?? 0,
        idpersona: data.idpersona?? 0, 
        tipomotivo: data.tipomotivo?? "", 
        motivo: data.motivo?? "", 
        ultimoCambio: data.ultimoCambio?? "", 
    }
}

export function getProductoMotivoImport(): TblDecInvMotivoProdTermin{
    return{
        iddecinvmotivoprodtermin: 0,
        idpersona: 0, 
        tipomotivo: "O", 
        motivo: "Importado mediante Scopus", 
        ultimoCambio: "", 
    }
}